import React, { useCallback } from 'react';
import Auth from 'j-toker';
import { connect } from 'react-redux';
import styled from 'styled-components';
import TicketForm from '../../../TicketForm/TicketForm';
import InternalCommentsContainer from './InternalComments/InternalCommentsContainer';
import {
  createOrUpdateMaintenanceTicket,
  updatePartsContractorNeeded,
} from 'actions/maintenanceActions';
import { saveTicket, getTicket } from 'actions/maintenanceTicketActions';
import { media } from 'helpers/MediaHelper';
import VendorCommentsContainer from './InternalComments/VendorCommentsContainer';

const BodyContent = styled.div`
  padding: 24px 24px 35px;
  overflow-y: scroll;
  height: inherit;

  ${media.mobile`
    padding: 24px 24px 80px;
  `};
`;

const Details = (props) => {
  const {
    updateTicket,
    updatePartsContractorNeeded,
    setTicketData,
    onSubmissionComplete,
    setIsLoading,
    setSuccess,
    setProposedScheduledResponse,
    readOnly,
  } = props;
  const userTypeMaintenance = Auth.user.type === 'maintenance';
  const partsContractorNeededStatuses = [
    'Parts Needed',
    'Parts Needed Review',
    'Contractor Needed',
    'Contractor Needed Review',
  ];
  const partsContractorNeededReview =
    userTypeMaintenance && partsContractorNeededStatuses.includes(props.formData.status);

  const evaluateEnvironmentalTesting = (values) => {
    if (values.environmental_testing === false) {
      return 'not_completed';
    } else if (values.environmental_testing_result === true) {
      return 'positive';
    } else {
      return 'negative';
    }
  };

  const afterSubmissionCallback = useCallback(() => {
    onSubmissionComplete().then(() => {
      setIsLoading(false);
      setSuccess(true);
    });
  }, [onSubmissionComplete, setIsLoading, setSuccess]);

  const handleSubmit = useCallback(
    (values) => {
      setIsLoading(true);

      const payload = {
        ...values,
        abatement_date: values.abatement_date,
        environmental_testing: evaluateEnvironmentalTesting(values),
      };

      // without those params, the endpoint will throw an error.
      if (
        partsContractorNeededReview &&
        payload.id &&
        payload.responsible_for_action &&
        payload.contractor_part_type
      ) {
        updatePartsContractorNeeded(payload.id, payload).done(() => {
          getTicket(payload.id);
          afterSubmissionCallback();
        });
      } else {
        updateTicket(payload, payload.id).done((response) => {
          setTicketData(response.value.maintenance_ticket);
          afterSubmissionCallback();
        });
      }
    },
    [
      updateTicket,
      setTicketData,
      updatePartsContractorNeeded,
      partsContractorNeededReview,
      afterSubmissionCallback,
      setIsLoading,
    ]
  );

  return (
    <BodyContent>
      <React.Fragment>
        <TicketForm
          mode="edit"
          formName={props.formName}
          formData={props.formData}
          handleSubmit={handleSubmit}
          imageMaxSize={props.imageMaxSize}
          readOnly={readOnly}
          setIsLoading={setIsLoading}
          setProposedScheduledResponse={setProposedScheduledResponse}
        />
        <InternalCommentsContainer
          ticketID={props.formData.id}
          comments={props.formData.internal_comments}
          onSubmissionComplete={afterSubmissionCallback}
          setIsLoading={setIsLoading}
        />
        {props.formData.vendor_comments.length > 0 && (
          <VendorCommentsContainer comments={props.formData.vendor_comments} />
        )}
      </React.Fragment>
    </BodyContent>
  );
};

const mapStoreToProps = (store) => ({ imageMaxSize: store.userTypes.imageMaxSize });
const mapDispatchToProps = {
  updateTicket: createOrUpdateMaintenanceTicket,
  updatePartsContractorNeeded: updatePartsContractorNeeded,
  setTicketData: saveTicket,
};

export default connect(mapStoreToProps, mapDispatchToProps)(Details);
